import axios from 'axios'
import config from "./config.js";

import { Message } from 'element-ui';


// create an axios instance
const service = axios.create({
    baseURL: config.baseUrl, // url = base url + request url
    withCredentials: false, // send cookies when cross-domain requests 注意：withCredentials和后端配置的cross跨域不可同时使用
    timeout: 100000, // request timeout
    crossDomain: true
})

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//配置成功后的拦截器
service.interceptors.response.use(response => {

    console.log("response", response);
    if(response.status && !String(response.status).startsWith("20")){
        Message({
            type: 'error',
            message: '网络异常，请稍后重试'
        });
        return response
    }else {
        
        return response.data;
    }

   
}, error => {
    console.log("error", error);
    Message({
        type: 'error',
        message: '网络错误，请稍后重试'
    });
    return Promise.reject(error)
})


export default service
